module.exports = function() {
  return new Worker(__webpack_public_path__ + "5902b4fe58ab31962186.worker.js");
};